const criteriaApp = angular.module('criteria', [
    'commons.app',
]);